<template>
  <div id="contenedor-ejecucion-configuracion-plantillas-main">
    <v-container
      fluid>
      <tool-bar
        v-on:nuevaPlantilla="nuevaPlantilla">
      </tool-bar>
      <v-card
        flat>
        <v-card-text>
          <listado
            :modulo="modulo"
            :listadoPlantillas="getPlantillas">
          </listado>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog
      v-model="mostrarRegistrarNuevaPlantilla"
      width="450"
      persistent>
      <nueva
        :modulo="modulo"
        v-on:cerrar="nuevaPlantilla">
      </nueva>
    </v-dialog>
    <v-dialog
        persistent
        v-model="mostrarEliminarPlantilla"
        width="450">
          <eliminar
          :plantillaEliminar="plantillaEliminar"
          :modulo="modulo"
          v-on:cerrar="cerrarEliminarPlantilla">

          </eliminar>

        </v-dialog>
  </div>
</template>

<script>
import PLANTILLAS_POR_MODULO from '@/graphql/querys/administracion/configuracion/plantillas/plantillaPorModulo.gql';
import ToolBar from './ToolBar.vue';
import Nueva from '@/components/administracion/configuracion/plantillas/Nueva.vue';
import Listado from '@/components/administracion/configuracion/plantillas/listado/Main.vue';
import Eliminar from '@/components/administracion/configuracion/plantillas/Eliminar.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'EjecucionConfiguracionPlantillasMain',
  components: {
    Nueva,
    ToolBar,
    Listado,
    Eliminar,
  },
  data() {
    return {
      mostrarRegistrarNuevaPlantilla: false,
      mostrarEliminarPlantilla: false,
      modulo: 'ejecucion',
      plantillaEliminar: {},
    };
  },
  apollo: {
    plantillaPorModulo: {
      query: PLANTILLAS_POR_MODULO,
      variables() {
        return {
          modulo: this.modulo,
        };
      },
    },
  },
  mounted() {
    eventBus.$on('eliminar-plantilla', (plantilla) => {
      this.plantillaEliminar = plantilla;
      this.mostrarEliminarPlantilla = true;
    });
  },
  methods: {
    nuevaPlantilla() {
      this.mostrarRegistrarNuevaPlantilla = !this.mostrarRegistrarNuevaPlantilla;
    },
    cerrarEliminarPlantilla() {
      this.mostrarEliminarPlantilla = !this.mostrarEliminarPlantilla;
    },
  },
  computed: {
    getPlantillas() {
      if (!this.plantillaPorModulo) return [];
      return this.plantillaPorModulo
        .slice().sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    },
  },
};
</script>

<style lang="scss">

</style>
